import { environment } from 'src/environments/environment';

export class ConsoleLogger {

  public static enableDebug: boolean = true;
  public static portaljsDebug  = localStorage.getItem('portaljs_debug') === 'true';
  public static debug(msg: string, error?:any) {

    if (!this.portaljsDebug) {
      if ( environment.production) return; 'PORTAL_TEST_CODE'; // eslint-disable-line
    }

    if (ConsoleLogger.enableDebug) {
      console.debug(`[Portal] ${msg}`, error);
    }
  }

  public static info(msg: string){
    console.info(`[Portal] ${msg}`);
  }

  public static error(msg: string, error?:any){
    console.error(`[Portal] ${msg}`, error);
  }
}
